import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DuplicateIcon } from 'foundations-assets';
import { copyWithFloatingMessage } from '../../../../utils/copyToClipboard';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackEvent } from '../../../../usage-tracking/clients/usageTracker';
import { getCopyCitation } from '../../events/ReplyRecommendationCitationEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const copyCitation = citation => {
  copyWithFloatingMessage(citation.deepLink || citation.url, /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.reply-recommendations.citations.copied"
  }));
  trackEvent(getCopyCitation());
};
export const ReplyRecommendationCitationCopyButton = ({
  citation
}) => {
  return /*#__PURE__*/_jsx(IconButton, {
    tooltip: "Copy Link",
    use: "link",
    onClick: () => {
      copyCitation(citation);
    },
    children: /*#__PURE__*/_jsx(DuplicateIcon, {})
  });
};
ReplyRecommendationCitationCopyButton.displayName = 'ReplyRecommendationCitationCopyButton';